/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notifications/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import TysiaIconCheckFilled from 'DesignSystem/Svgs/TysiaIconCheckFilled/index'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'
import TysiaIconCloudWarning from 'DesignSystem/Svgs/TysiaIconCloudWarning/index'
import TysiaIconInfoFilled from 'DesignSystem/Svgs/TysiaIconInfoFilled/index'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2WarningIcon from 'DesignSystem/Svgs/Tysiav2WarningIcon/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Notifications({
  children,
  viewPath = "/DesignSystem/Notifications",
  isOk,
  isError,
  isAlert,
  isWarning,
  isInfo,
  title,
  message,
  hasAction,
  onClickAction,
  textAction,
  onClose
  
}) {
  let isBefore = useIsBefore()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsOrange600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.600'
        })
let dtColorsBlue700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.700'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Notifications.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-2rAuDm': dtColorsWhite,'--bblr-2-2rAuDm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-2rAuDm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-2rAuDm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-2rAuDm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-2rAuDm': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-7-2rAuDm': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-8-2rAuDm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-9-2rAuDm': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-10-2rAuDm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-11-2rAuDm': isBefore ? 0 : 1}}
 className={`views-block new-shadow ${styles.Horizontal}`}
>
<fromFlow.When is={isOk}>
<TysiaIconCheckFilled
  viewPath={`${viewPath}/TysiaIconCheckFilled`}
 width={20}
 height={20}
/>
</fromFlow.When>
<fromFlow.When is={isError}>
<TysiaIconCloudWarning
  viewPath={`${viewPath}/TysiaIconCloudWarning`}
 width={20}
 height={20}
/>
</fromFlow.When>
<fromFlow.When is={isAlert}>
<TysiaIconWarning
  viewPath={`${viewPath}/TysiaIconWarning`}
 fill={dtColorsOrange600}
 width={20}
 height={20}
/>
</fromFlow.When>
<fromFlow.When is={isWarning}>
<Tysiav2WarningIcon
  viewPath={`${viewPath}/Tysiav2WarningIcon`}
 width={20}
 height={20}
/>
</fromFlow.When>
<fromFlow.When is={isInfo}>
<TysiaIconInfoFilled
  viewPath={`${viewPath}/TysiaIconInfoFilled`}
 width={20}
 height={20}
 color={dtColorsBlue700}
/>
</fromFlow.When>
<div
  data-testid="Notifications.Vertical"
  data-view-path={viewPath}
 style={{'--ml-12-2rAuDm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-13-2rAuDm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={title}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 color={dtColorsNeutral900}
 size="normal"
 text={title}
 marginBottom={dtSpaceXxs}
/>
</fromFlow.When>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 text={message}
/>
<fromFlow.When is={hasAction}>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 marginTop={dtSpaceXs}
 marginLeft="auto"
 onClick={onClickAction}
 text={textAction}
/>
</fromFlow.When>
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 marginTop={-2}
 onClick={onClose}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconClose
{...childProps}
  viewPath={`${viewPath}/TysiaIconClose`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}